import React from 'react';
import {ReactComponent as ReactLogo} from "./logo.svg";
import "./_header.scss";
// import DropdownLang from "../utils/DropdownLang";
//import {Col, Row} from "reactstrap";

const ExerciseHeader = ({nameOfExercise}) => {

  return (
    <header id={"header"} >
        <div className={"header-left cviceni-info"}>
          <span data-cy="header-exercise-name" className={"title"}>{nameOfExercise}</span>
          <i className={"icon-svg"}>
            <ReactLogo />
          </i>
        </div>
        <div className={"header-center"}></div>
        <div className={"header-right"}>
            {/*<div className={"dropdown-lang"}>*/}
            {/*  <DropdownLang/>*/}
            {/*</div>*/}
        </div>

      {/*<i className={"icon-svg"}>*/}
      {/*  <ReactLogo id={"logo"}/>*/}
      {/*</i>*/}
      {/*<Row>*/}
      {/*  <Col className={"title-col"}>*/}
      {/*    <span data-cy="header-exercise-name" className={"title"}>{nameOfExercise}</span>*/}
      {/*  </Col>*/}
      {/*  /!*<Col className={"dropdown-lang"}>*!/*/}
      {/*  /!*  <DropdownLang/>*!/*/}
      {/*  /!*</Col>*!/*/}
      {/*</Row>*/}


    </header>
  );
}


export default ExerciseHeader;
